// @flow

import type {BrandingSettings} from 'src/types/events';
import type {BeefreeDocument} from 'src/components/lib/beefree-editor';

import {getBeefreeFooterHtml, getBeefreeFooterHtmlOld} from 'src/utils/events';


export default function templateFactory(
  brandingSettings: BrandingSettings,
  isContentSubscriptionV2Footer: boolean,
  isTranscationalCategory: boolean,
  reason: ?string,
  agencyName: string,
): BeefreeDocument {
  const agencyColor = brandingSettings?.color || '#0068A5';
  const agencyLogoUrl =
    brandingSettings?.logo ||
    'https://s3.us-west-2.amazonaws.com/media.sense/email/logo/sense_logo.png';

  return {
    page: {
      body: {
        container: {
          style: {
            'background-color': '#ffffff',
          },
        },
        content: {
          computedStyle: {
            align: 'center',
            linkColor: '#8a3c90',
            messageBackgroundColor: 'transparent',
            messageWidth: '900.00px',
          },
          style: {
            color: '#000000',
            'font-family': 'Arial, Helvetica, sans-serif',
          },
        },
        type: 'mailup-bee-page-properties',
        webFonts: [
          {
            fontFamily:
              '\'Abril Fatface\', Arial, \'Helvetica Neue\', Helvetica, sans-serif',
            name: 'Abril Fatface',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Abril+Fatface',
          },
          {
            fontFamily: '\'Bitter\', Georgia, Times, \'Times New Roman\', serif',
            name: 'Bitter',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Bitter',
          },
          {
            fontFamily:
              '\'Cabin\', Arial, \'Helvetica Neue\', Helvetica, sans-serif',
            name: 'Cabin',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Cabin',
          },
          {
            fontFamily:
              '\'Droid Serif\', Georgia, Times, \'Times New Roman\', serif',
            name: 'Droid Serif',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Droid+Serif',
          },
          {
            fontFamily: '\'Lato\', Tahoma, Verdana, Segoe, sans-serif',
            name: 'Lato',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Lato',
          },
          {
            fontFamily:
              '\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
            name: 'Open Sans',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Open+Sans',
          },
          {
            fontFamily: '\'Roboto\', Tahoma, Verdana, Segoe, sans-serif',
            name: 'Roboto',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Roboto',
          },
          {
            fontFamily: '\'Source Sans Pro\', Tahoma, Verdana, Segoe, sans-serif',
            name: 'Source Sans Pro',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro',
          },
          {
            fontFamily: '\'Merriwheater\', \'Georgia\', serif',
            name: 'Merriwheater',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Merriweather',
          },
          {
            fontFamily:
              '\'Montserrat\', \'Trebuchet MS\', \'Lucida Grande\', \'Lucida Sans Unicode\', \'Lucida Sans\', Tahoma, sans-serif',
            name: 'Montserrat',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Montserrat',
          },
          {
            fontFamily:
              '\'Nunito\', Arial, \'Helvetica Neue\', Helvetica, sans-serif',
            name: 'Nunito',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Nunito',
          },
          {
            fontFamily:
              '\'Oswald\', Arial, \'Helvetica Neue\', Helvetica, sans-serif',
            name: 'Oswald',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Oswald',
          },
          {
            fontFamily:
              '\'Oxygen\', \'Trebuchet MS\', \'Lucida Grande\', \'Lucida Sans Unicode\', \'Lucida Sans\', Tahoma, sans-serif',
            name: 'Oxygen',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Oxygen',
          },
          {
            fontFamily: '\'Permanent Marker\', Impact, Charcoal, sans-serif',
            name: 'Permanent Marker',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Permanent+Marker',
          },
          {
            fontFamily:
              '\'Roboto Slab\', Arial, \'Helvetica Neue\', Helvetica, sans-serif',
            name: 'Roboto Slab',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Roboto+Slab',
          },
          {
            fontFamily: '\'Ubuntu\', Tahoma, Verdana, Segoe, sans-serif',
            name: 'Ubuntu',
            type: 'default',
            url: 'https://fonts.googleapis.com/css?family=Ubuntu',
          },
        ],
      },
      description: '',
      rows: [
        {
          columns: [
            {
              'grid-columns': 12,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center fixedwidth',
                      width: '100px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '212px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/logooo.png',
                      width: '238px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: 'cba3555b-0fda-414f-a2b4-a99707015ab2',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '30px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: '336988e4-8197-4f75-ac39-a9303503d668',
                },
                {
                  descriptor: {
                    computedStyle: {
                      height: 42,
                      width: 52,
                    },
                    heading: {
                      style: {
                        color: '#000000',
                        direction: 'ltr',
                        'font-family':
                          '\'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace',
                        'font-size': '42px',
                        'font-weight': '400',
                        'letter-spacing': '-4px',
                        'line-height': '200%',
                        'link-color': '#8a3c90',
                        'text-align': 'center',
                      },
                      text: '<span class="tinyMce-placeholder">Attend Our FREE 6 Week class to become a CNA!</span>',
                      title: 'h1',
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      'text-align': 'center',
                      width: '100%',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-heading',
                  uuid: '5be515f5-b08a-48a9-b49f-04dc68e09661',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '86efbd77-11c1-4b6b-9847-6bec0ef66c49',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          type: 'one-column-empty',
          uuid: '0ced41ec-2fdd-4ec2-a25b-5b5b5df96cd0',
        },
        {
          columns: [
            {
              'grid-columns': 6,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center',
                      hideContentOnMobile: false,
                      width: '100%',
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '0px',
                      'padding-right': '20px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                    video: {
                      controls: true,
                      iconColor1: '#ffffff',
                      iconColor2: '#000000',
                      iconSize: 65,
                      iconSrc:
                        'https://app-rsrc.getbee.io/public/resources/components/widgetBar/video-content-icon-sets/light/type-01.png',
                      iconType: 1,
                      loop: false,
                      mode: 'embedded',
                      src: 'https://www.youtube.com/embed/9L_sGURszPk',
                      thumbAlt: 'Marquis: Why We Serve',
                      thumbRatio: '16-9',
                      thumbSrc:
                        'https://img.youtube.com/vi/9L_sGURszPk/maxresdefault.jpg',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-video',
                  uuid: 'e2eefcaa-58aa-43a3-97ac-1b0eea3d6067',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '15px',
                      'padding-left': '55px',
                      'padding-right': '60px',
                      'padding-top': '30px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 18px; font-size: 12px; font-family: Ubuntu, Tahoma, Verdana, Segoe, sans-serif;" data-mce-style="line-height: 18px; font-size: 12px; font-family: Ubuntu, Tahoma, Verdana, Segoe, sans-serif;"><p style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;" data-mce-style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;"><span style="font-size: 15px; line-height: 22px;" data-mce-style="font-size: 15px; line-height: 22px;">As a Certified Nursing Assistant, your passion for others and attention to detail have taken you far.&nbsp;You see every day as a new opportunity to change a life.&nbsp;You have a purpose, a drive, a reason! You make a difference. Are you ready to leverage your skills to make a lasting impact within an evolving industry?</span><br><br></p><p style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;" data-mce-style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;"><span style="font-size: 15px; line-height: 22px;" data-mce-style="font-size: 15px; line-height: 22px;"><strong><span style="color: #fc4621; line-height: 18px;" data-mce-style="color: #fc4621; line-height: 18px;">Join one of the most valuable teams at Marquis Companies today!</span><br><br></strong></span></p><p style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;" data-mce-style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;"><span style="font-size: 15px; line-height: 22px;" data-mce-style="font-size: 15px; line-height: 22px;">Marquis Companies sees our CNA\'s for the caring, loving, attentive and hardworking individuals that they are. We know the sacrifices you make and we provide immense support and mentorship to make sure you succeed.&nbsp;</span><br><br></p><p style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;" data-mce-style="text-align: center; font-size: 15px; line-height: 22px; word-break: break-word;"><span style="font-size: 15px; color: #fc4621; line-height: 22px;" data-mce-style="font-size: 15px; color: #fc4621; line-height: 22px;"><strong>We make it easy to join Marquis by providing a hefty benefits package that includes&nbsp;Tuition Reimbursement!</strong></span></p></div>',
                      style: {
                        color: '#555555',
                        'font-family':
                          '\'Ubuntu\', Tahoma, Verdana, Segoe, sans-serif',
                        'line-height': '150%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: 'dd40814a-051b-436b-9b81-9c07187d03dc',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '60px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: 'a0ed516f-c99b-4611-b189-d22b7d080e64',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '30px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: 'b800269a-eb37-4176-a002-6cdc5c5df2a2',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: 'deb0df7e-ea13-4845-bbd8-b0a5e340fc4f',
            },
            {
              'grid-columns': 6,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      align: 'center',
                      hideContentOnMobile: false,
                    },
                    divider: {
                      style: {
                        'border-top': 'solid 1px #dddddd',
                        width: '100%',
                      },
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-divider',
                  uuid: '0f73f5f3-3fd9-43c2-95b3-a9b7bc3191fe',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '024b1e66-7f1e-4348-b123-3ce999519a4a',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          name: 'bee-common-widget-bar.row-icon-2',
          synced: false,
          type: 'two-columns-empty',
          uuid: '8be1c09d-34de-499e-9fcd-f8fa9bdd3f7d',
        },
        {
          columns: [
            {
              'grid-columns': 12,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 18px; font-size: 12px; font-family: \'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace;" data-mce-style="line-height: 18px; font-size: 12px; font-family: \'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace;"><p style="font-size: 16px; line-height: 24px; text-align: center; word-break: break-word;" data-mce-style="font-size: 16px; line-height: 24px; text-align: center; word-break: break-word;"><strong><span style="font-size: 30px; color: #fc4621; line-height: 45px;" data-mce-style="font-size: 30px; color: #fc4621; line-height: 45px;">Benefits &amp; Compensation</span></strong></p></div>',
                      style: {
                        color: '#dc582a',
                        'font-family':
                          '\'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace',
                        'letter-spacing': '-2px',
                        'line-height': '150%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '06a4249f-67dc-400d-9d40-e44e1ff2553b',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: 'c12f72ee-e000-469c-90ee-5c5280bf6a6a',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          name: 'bee-common-widget-bar.row-icon-1',
          synced: false,
          type: 'one-column-empty',
          uuid: 'd1049f89-d7b4-4ff2-b69e-b9d469b3d869',
        },
        {
          columns: [
            {
              'grid-columns': 3,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center fixedwidth',
                      width: '135px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '123px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/1.jpg',
                      width: '147px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: '7b7bade9-0590-48b4-8a43-e810e20464cf',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 14px; font-size: 12px; font-family: inherit; text-align: center;" data-mce-style="line-height: 14px; font-size: 12px; font-family: inherit; text-align: center;"><strong> </strong><p style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;"><strong>COMPETITIVE COMPENSATION</strong></p>\n<strong> </strong></div>',
                      style: {
                        color: '#555555',
                        'font-family': 'inherit',
                        'line-height': '120%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: 'c4d926c6-c361-4cda-9fa0-26dce5037a5b',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '0px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif; text-align: center;" data-mce-style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif; text-align: center;">Our clients deserve the best, and that\'s why we hire the best. We can only do this by compensating accordingly.&nbsp;</div>',
                      style: {
                        color: '#555555',
                        'font-family':
                          '\'Roboto\', Tahoma, Verdana, Segoe, sans-serif',
                        'line-height': '180%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '64b93bde-127c-4916-951d-6ce523ec2343',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '19d28c4b-2ccc-4985-b4fa-f7082d71bb5f',
            },
            {
              'grid-columns': 3,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center autowidth',
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                      width: '156px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '118px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/0.jpg',
                      width: '156px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: '5c499778-635e-42b3-ae3b-300549d44170',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '5px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 14px; font-size: 12px; font-family: inherit;" data-mce-style="line-height: 14px; font-size: 12px; font-family: inherit;"><strong> </strong><p style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;"><strong>ROBUST BENEFITS PACKAGE</strong></p>\n<strong> </strong></div>',
                      style: {
                        color: '#555555',
                        'font-family': 'inherit',
                        'line-height': '120%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '39f4b918-5d5c-4ab0-9f8a-dad6352f62d4',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '0px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;" data-mce-style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;"><p style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;" data-mce-style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;">Behind the word mountains, far from the countries Vokalia and Consonantia.</p></div>',
                      style: {
                        color: '#555555',
                        'font-family':
                          '\'Roboto\', Tahoma, Verdana, Segoe, sans-serif',
                        'line-height': '180%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '4873a3ce-48d6-4777-8a87-15f18d4d87b4',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '993606cd-372c-4935-81c2-f001976ab78f',
            },
            {
              'grid-columns': 3,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center fixedwidth',
                      width: '180px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '93px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/2.jpg',
                      width: '145px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: 'ce23aa0a-bd20-47d8-891a-0285a89dd55a',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 14px; font-size: 12px; font-family: inherit;" data-mce-style="line-height: 14px; font-size: 12px; font-family: inherit;"><strong> </strong><p style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;"><strong>TUITION REIMBURSEMENT</strong></p>\n<strong> </strong></div>',
                      style: {
                        color: '#555555',
                        'font-family': 'inherit',
                        'line-height': '120%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '9c777aa3-d003-4634-92cb-67db0e3d5d25',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '15px',
                      'padding-left': '15px',
                      'padding-right': '15px',
                      'padding-top': '0px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;" data-mce-style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;"><p style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;" data-mce-style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;">We strongly believe in the power of education and support continued learning through an array of programs and incentives.</p></div>',
                      style: {
                        color: '#555555',
                        'font-family':
                          '\'Roboto\', Tahoma, Verdana, Segoe, sans-serif',
                        'line-height': '180%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: 'db6e2fd8-2be7-4692-9a36-6de031899e08',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '39aabc5b-4b51-40df-abf3-31012c5d92c9',
            },
            {
              'grid-columns': 3,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center fixedwidth',
                      width: '120px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '111px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/4.jpg',
                      width: '120px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: 'c3e31ad7-730d-47a6-804f-eb1d258a46ae',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 14px; font-size: 12px; font-family: inherit;" data-mce-style="line-height: 14px; font-size: 12px; font-family: inherit;"><strong> </strong><p style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px; text-align: center; word-break: break-word;"><strong>QUALITY RESULTS</strong></p>\n<strong> </strong></div>',
                      style: {
                        color: '#555555',
                        'font-family': 'inherit',
                        'line-height': '120%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '4f7092e7-c237-4191-a24c-b5b5e27eb808',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '5px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;" data-mce-style="line-height: 21px; font-size: 12px; font-family: Roboto, Tahoma, Verdana, Segoe, sans-serif;"><p style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;" data-mce-style="font-size: 12px; line-height: 21px; text-align: center; word-break: break-word;">By all national measures, we are excelling and creating better client outcomes with the right level of care and resources, at the right times.</p></div>',
                      style: {
                        color: '#555555',
                        'font-family':
                          '\'Roboto\', Tahoma, Verdana, Segoe, sans-serif',
                        'line-height': '180%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '1cf0098c-2da0-454a-8273-6e8c1b7faddc',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: 'b6dc370e-dfcc-497c-baee-8f9838f1eeed',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          name: 'bee-common-widget-bar.row-icon-4',
          synced: false,
          type: 'four-columns-empty',
          uuid: '2e14f4c4-5f70-455d-8e9d-387a2b767fef',
        },
        {
          columns: [
            {
              'grid-columns': 12,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center autowidth',
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                      width: '900px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '558px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/8.jpg',
                      width: '1267px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: 'a39e853d-f37d-4c01-ba81-879b4cab94e6',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '60px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: '8cd265d7-310e-466e-a97a-be8599950abc',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '60px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: '7c053243-381d-4c24-8864-89af27174c4f',
                },
                {
                  descriptor: {
                    computedStyle: {
                      height: 42,
                      width: 52,
                    },
                    heading: {
                      style: {
                        color: '#e36237',
                        direction: 'ltr',
                        'font-family':
                          '\'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace',
                        'font-size': '24px',
                        'font-weight': '700',
                        'letter-spacing': '-1px',
                        'line-height': '150%',
                        'link-color': '#8a3c90',
                        'text-align': 'center',
                      },
                      text: '<span class="tinyMce-placeholder">Why Choose Marquis to Elevate Your Nursing Career?</span>',
                      title: 'h1',
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '20px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '20px',
                      'text-align': 'center',
                      width: '100%',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-heading',
                  uuid: '8f25533f-7e52-424a-8dfc-35952e9df32c',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnAmp: false,
                      hideContentOnDesktop: false,
                      hideContentOnHtml: false,
                      hideContentOnMobile: false,
                    },
                    mobileStyle: {},
                    paragraph: {
                      computedStyle: {
                        linkColor: '#8a3c90',
                        paragraphSpacing: '15px',
                      },
                      html: '<p><strong>High-Quality Outcomes</strong>&nbsp;Marquis is an industry leader with 5-star quality ratings and&nbsp;low staff turnover.</p>\n<p><strong>Revolutionary Care Methods</strong>&nbsp;Our clinical teams are constantly embracing new technology allowing Marquis to grow, innovate and inspire across the nation.</p>\n<p><strong>Encouraged Collaboration&nbsp;</strong>The unique collaboration you will experience within our teams is imperative to the success of our staff and employees.</p>\n<p><strong>Continued Mentorship and Training&nbsp;</strong>We are the most supportive Long-Term Care company in the industry.&nbsp;Our team of&nbsp;experts will train and encourage you as you provide life-changing care.</p>\n<p><strong>Autonomous Work Environment</strong>&nbsp;Your voice as a Nurse is invaluable as we adjust our&nbsp;best practices to meet the needs of those we care for.</p>\n<p><strong>Accessible Advancement</strong>&nbsp;We value your professional growth and personal development goals through continued mentorship and promoting from within.</p>\n<p><strong>One Shared Goal&nbsp;</strong>&nbsp;Our staff of more than 4,000 individuals share one mission; to help others and those that we serve to live the best rest of their life. And we want you to be one of those 4,000.&nbsp;</p>',
                      style: {
                        color: '#101112',
                        direction: 'ltr',
                        'font-family': 'inherit',
                        'font-size': '13px',
                        'font-weight': '400',
                        'letter-spacing': '0px',
                        'line-height': '120%',
                        'text-align': 'left',
                      },
                    },
                    style: {
                      'padding-bottom': '60px',
                      'padding-left': '60px',
                      'padding-right': '60px',
                      'padding-top': '20px',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-paragraph',
                  uuid: 'c3c02c85-33b8-429d-8d94-22a5498b9bb7',
                },
                {
                  descriptor: {
                    computedStyle: {
                      align: 'center',
                      hideContentOnMobile: false,
                    },
                    divider: {
                      style: {
                        'border-top': '10px solid #e36237',
                        height: '1px',
                        width: '100%',
                      },
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-divider',
                  uuid: '54409bdb-8e03-4e3d-966a-36a68dbe47d3',
                },
                {
                  descriptor: {
                    computedStyle: {
                      height: 42,
                      width: 52,
                    },
                    heading: {
                      style: {
                        color: '#000000',
                        direction: 'ltr',
                        'font-family':
                          '\'Courier New\', Courier, \'Lucida Sans Typewriter\', \'Lucida Typewriter\', monospace',
                        'font-size': '28px',
                        'font-weight': '700',
                        'letter-spacing': '0px',
                        'line-height': '120%',
                        'link-color': '#8a3c90',
                        'text-align': 'center',
                      },
                      text: 'Take The Next Step!',
                      title: 'h1',
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '10px',
                      'text-align': 'center',
                      width: '100%',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-heading',
                  uuid: '3f08e184-e6f6-4bf5-bfcc-430769fedf6e',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '30px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: '55ce49d4-be98-4a49-8cb8-a088f9d921d4',
                },
                {
                  descriptor: {
                    button: {
                      href: 'CONTACT OUR CAREER SPECIALISTS',
                      label:
                        '<div class="txtTinyMce-wrapper" style="font-family: inherit;" data-mce-style="font-family: inherit;"><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">CONTACT OUR CAREER SPECIALISTS</p></div>',
                      style: {
                        'background-color': '#dc582a',
                        'border-bottom': '0px solid transparent',
                        'border-left': '0px solid transparent',
                        'border-radius': '4px',
                        'border-right': '0px solid transparent',
                        'border-top': '0px solid transparent',
                        color: '#ffffff',
                        direction: 'ltr',
                        'font-family': 'inherit',
                        'font-size': '16px',
                        'font-weight': '400',
                        'line-height': '200%',
                        'max-width': '100%',
                        'padding-bottom': '5px',
                        'padding-left': '20px',
                        'padding-right': '20px',
                        'padding-top': '5px',
                        width: 'auto',
                      },
                    },
                    computedStyle: {
                      height: 42,
                      hideContentOnMobile: false,
                      width: 334,
                    },
                    mobileStyle: {},
                    style: {
                      'padding-bottom': '5px',
                      'padding-left': '5px',
                      'padding-right': '5px',
                      'padding-top': '5px',
                      'text-align': 'center',
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-button',
                  uuid: '3901eebb-8132-4d3e-aa88-89a391e9893b',
                },
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnMobile: false,
                    },
                    spacer: {
                      style: {
                        height: '105px',
                      },
                    },
                  },
                  locked: false,
                  type: 'mailup-bee-newsletter-modules-spacer',
                  uuid: '96a0c43f-bed3-4ad0-b795-444ea2031528',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '43bf39ae-2de7-4e53-8003-1b38e9c4c461',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          name: 'bee-common-widget-bar.row-galleries-1',
          synced: false,
          type: 'one-column-empty',
          uuid: '51b61ef0-2a2d-4b53-95f5-2da38269fa87',
        },
        {
          columns: [
            {
              'grid-columns': 4,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      class: 'center fixedwidth',
                      width: '100px',
                    },
                    image: {
                      alt: 'I\'m an image',
                      dynamicSrc: '',
                      height: '212px',
                      href: '',
                      src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/945298_929772/logooo.png',
                      width: '238px',
                    },
                    style: {
                      'padding-bottom': '0px',
                      'padding-left': '0px',
                      'padding-right': '0px',
                      'padding-top': '0px',
                      width: '100%',
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-image',
                  uuid: '3f4d7052-8782-4f3e-adc4-732958d1a814',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '54df894a-1178-4358-ab8f-96dd53795717',
            },
            {
              'grid-columns': 8,
              modules: [
                {
                  descriptor: {
                    computedStyle: {
                      hideContentOnDesktop: false,
                      hideContentOnMobile: false,
                    },
                    style: {
                      'padding-bottom': '10px',
                      'padding-left': '10px',
                      'padding-right': '10px',
                      'padding-top': '10px',
                    },
                    text: {
                      computedStyle: {
                        linkColor: '',
                      },
                      html: '<div class="txtTinyMce-wrapper" style="line-height: 14px; font-size: 12px; font-family: inherit;" data-mce-style="line-height: 14px; font-size: 12px; font-family: inherit;"><p style="line-height: 14px; word-break: break-word;" data-mce-style="line-height: 14px; word-break: break-word;">Marquis is proud to be an Equal Opportunity Employer. Marquis does not discriminate on the basis of age, color, race, national origin, gender, religion, marital status, disability, veteran, military status, sexual identity or expression, sexual orientation, or any other basis prohibited by local, state, or federal law.<br><br></p><p style="line-height: 14px; word-break: break-word;" data-mce-style="line-height: 14px; word-break: break-word;">© Marquis Companies, all rights reserved.</p></div>',
                      style: {
                        color: '#555555',
                        'font-family': 'inherit',
                        'line-height': '120%',
                      },
                    },
                  },
                  type: 'mailup-bee-newsletter-modules-text',
                  uuid: '04efa809-85c9-4f13-9a9b-8440cec492c9',
                },
              ],
              style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
              },
              uuid: '58b92bbb-afa0-4fda-b714-ec7eb2f71b77',
            },
          ],
          container: {
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
            },
          },
          content: {
            computedStyle: {
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
            },
            style: {
              'background-color': 'transparent',
              'background-image': 'none',
              'background-position': 'top left',
              'background-repeat': 'no-repeat',
              color: '#000000',
              width: '900.00px',
            },
          },
          locked: false,
          name: 'bee-common-widget-bar.row-icon-2-left',
          synced: false,
          type: 'two-columns-4-8-empty',
          uuid: 'e87e400e-2fa9-4f5c-9cd4-028817e1f0b1',
        },
      ],
      template: {
        name: 'template-base',
        type: 'basic',
        version: '2.0.0',
      },
      title: '',
    },
  };
}
